// VehInfoLog.js
import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import useClientSize from '../hook/useClientSize';
import CustInfoSelector from '../cust_info/CustInfoSelector';
import VehInfoNarrowList from '../veh_info/VehInfoNarrowList';
import VehInfoLogList from './VehInfoLogList';
import ResponseAlert from '../message/ResponseAlert';
import { useLazyQuery } from '@apollo/client';
import { SIMPLE_LIST_VEH_INFO } from '../veh_info/VehInfoGql';
import { LIST_VEH_INFO_LOG } from './VehInfoLogGql';
import { AppObject, AppNumber, AppPalette, AppWord } from '../../model/AppConst';
import ValueUtil from '../../model/ValueUtil';
import { userInfoRepo, NoUser } from '../../model/CvoModel';
import Util from '../../model/Util';

const dcPad = AppNumber.dataContainerPadding;

const VehInfoLogContainer = styled(Box)({
	position:"absolute", top:dcPad, right:dcPad, bottom: dcPad, left: dcPad, display:'flex', flexDirection: 'column'
});
const HeaderBox = styled(Box)({ // in VehInfoLogContainer
    height: AppNumber.HeaderToolBoxHeight, display:'flex', alignItems:'center'
});
const SubjectsAndLog = styled(Box)({flexGrow:1, display:'flex'}); // in VehInfoLogContainer

// in SubjectsAndLog
const SubjectListBoxWidth = 300;
const SubjectListBox = styled(Box)({marginRight:10, display:'flex', width:SubjectListBoxWidth, border: AppPalette.BorderCCC, borderRadius:5});


export default function VehInfoLog({
    custId
}) {
    const [custInfo, setCustInfo] = useState(null);
    const [vehicle, setVehicle] = useState(null);
    const [vehInfoList, setVehInfoList] = useState([]);
    const [vehInfoLogList, setVehInfoLogList] = useState([]);
    const [responseAlert, setResponseAlert] = useState(null);
    const clientSize = useClientSize();
    const loadedRef = useRef(0);

    // ##### Call GraphQL to get List #####
    const [getVehInfoLogList, responseList] = useLazyQuery(LIST_VEH_INFO_LOG, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {
            onCompleteGetList(data, option);
        },
		onError: (error) => {setResponseAlert({open:true, error: error, title: '차량정보변경이력 조회 오류'})}
    });
    const [getVehInfoList, responseVehInfoList] = useLazyQuery(SIMPLE_LIST_VEH_INFO, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {
            onCompleteVehInfoList(data, option);
        },
		onError: (error) => {setResponseAlert({open:true, error: error, title: '차량목록 조회 오류'})}
    });

    useEffect(() => {
        if(custId) {
            setCustInfo({custId: custId});
        }
    }, [custId]);

    useEffect(() => {
        if(custInfo) getVehInfoList({variables:{custId:custInfo.custId}});
    }, [custInfo, getVehInfoList]);

    const onCompleteGetList = (data, clientOption) => {
        if(data.vehInfoLogList) {
            setVehInfoLogList(data.vehInfoLogList);
            if(data.vehInfoLogList.length === 0) {
                Util.bubbleSnack('차량정보변경이력 없음', {duration: 800});
            }
        }
    };

    const onCompleteVehInfoList = (data, clientOption) => {
        if(data.vehInfoList) {
            loadedRef.current = new Date().getTime();
            setVehInfoList(data.vehInfoList);
        }
    };

    const onChangeCustSelection = (custInfo) => {
        setCustInfo(custInfo);
    };

    const onClickVehicle = (veh) => {
        if(!vehicle || veh.vehId !== vehicle.vehId) {
            setVehicle(veh);
            getVehInfoLogList({variables:{vehId: veh.vehId, custId: veh.custId}});
        }
    };

    const onRequestReloadVehList = () => {
        if(custInfo) {
            if((new Date()).getTime() - loadedRef.current > 5000) {
                getVehInfoList({variables:{custId:custInfo.custId}});
            }
            else {
                Util.bubbleSnack(AppWord.NO_RELOAD_IN_5_SEC, {duration: 1500});
            }
        }
    };

    if(ValueUtil.hasAnyAuthError(
        responseList,
        responseVehInfoList
        )) userInfoRepo(NoUser);

	// AppMain.js의 resize에 따라 창을 채우는 고정된 높이를 갖는 <ContentContainer> 안에 놓임.
    return (
        <VehInfoLogContainer>
            <HeaderBox>
                {
                    custId ? null :
                    <CustInfoSelector
                        popoverHeight={clientSize.dataAreaHeight - AppNumber.HeaderToolBoxHeight - 50}
                        onChange={onChangeCustSelection}
                    />}
            </HeaderBox>
            <SubjectsAndLog>
                <SubjectListBox>
                    <VehInfoNarrowList
                        columnList={['vehPlates', 'driverName']}
                        records={vehInfoList}
                        selected={vehicle}
                        onClickItem={onClickVehicle}
                        onRequestReload={onRequestReloadVehList}
                    />
                </SubjectListBox>
                <VehInfoLogList
                    records={vehInfoLogList}
                />
            </SubjectsAndLog>
            <ResponseAlert open={responseAlert ? responseAlert.open : false}
                alertData={responseAlert}
                onClose={() => {setResponseAlert(null)}}/>
        </VehInfoLogContainer>
    )
}
